var LoginType = /* @__PURE__ */ ((LoginType2) => {
  LoginType2["Account"] = "account";
  LoginType2["VerificationCode"] = "verificationCode";
  LoginType2["Feishu"] = "feishu";
  return LoginType2;
})(LoginType || {});
export {
  LoginType
};
